import { Injectable } from '@angular/core';
import { FiscalDashboardModel, FiscalDashboardQueryPayload } from '@app/data';
import { ApiService } from '@app/gateway';

/**
 * Fiscal dashboard reads nfeclass-api directly.
 * Why: dash-api JWT has no account list and a second Postgres source would duplicate SQL already in nfeclass.
 */
@Injectable({ providedIn: 'root' })
export class FiscalService {
  constructor(protected readonly apiService: ApiService) {}

  public async dashboard(data: FiscalDashboardQueryPayload): Promise<FiscalDashboardModel> {
    try {
      const result: FiscalDashboardModel = await this.apiService.post({
        path: 'invoices/dashboard',
        data,
        base: 'nfe',
      });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load fiscal dashboard.';
      throw new Error(message, { cause: e });
    }
  }
}
